<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();

const router = useRouter();
const toggleSidebar = () => {
  if (window.innerWidth > 991) {
    const sidebar = document.querySelector(".dashboard-main-view");
    if (sidebar) {
      sidebar.classList.toggle("sidebar-collapse");
    }
  }
};

const logout = () => {
  store.commit("auth/SET_USER_TOKEN", null);
  router.push({ name: "login" });
};
</script>

<template>
  <nav class="main-header navbar navbar-expand navbar-dark">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          class="nav-link"
          data-widget="pushmenu"
          role="button"
          @click="toggleSidebar"
        >
          <font-awesome-icon :icon="['fas', 'bars']" />
        </a>
      </li>
      <router-link
        to="/dashboard/courses"
        class="nav-item d-none d-sm-inline-block"
      >
        <a class="nav-link">Courses</a>
      </router-link>
      <router-link
        to="/dashboard/devices"
        class="nav-item d-none d-sm-inline-block"
      >
        <a class="nav-link">Devices</a>
      </router-link>
    </ul>

    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <form method="POST" @click="logout()">
          <a class="nav-link">
            <font-awesome-icon :icon="['fas', 'fa-sign-out-alt']" />
            Log Out
          </a>
        </form>
      </li>
    </ul>
  </nav>
</template>
